import { render, staticRenderFns } from "./tableHeader.vue?vue&type=template&id=3a33a4e2"
import script from "./tableHeader.vue?vue&type=script&lang=js"
export * from "./tableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports